import ImageLazy from '~/components/base/ImageLazy.vue'

export default defineNuxtPlugin((nuxtApp) => {
  // Register ImageLazy component globally
  nuxtApp.vueApp.component('ImageLazy', ImageLazy)
})

